<template>
    <div class="sidebar-wrapper">
        <CCDrawer></CCDrawer>
    </div>
</template>

<script>

  import CCDrawer from '@/components/common/CCDrawer';

  export default {
    name: "cc-sidebar",
    components: {
      CCDrawer
    },
    data(){
      return {

      }
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
    .sidebar-wrapper {
        background-color: $side-bar-background-color;
        width: 48px;

        .sidebar-button-wrapper {
            padding-top: 15px;
        }

        .left-sidebar-buton-wrapper {
            margin-top: 10px;

            & > span .icon {
                font-size: 2rem;
            }
        }
    }

    .left-side-menu {
        background-color: #666666;
        left: 0;
        position: absolute;
        width: 10vw;
        z-index: 9999;
    }

    @include mobile-only{
        .sidebar-wrapper {
            display: none;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/common/CCSideBar.vue